import script from "./list-label-value.vue?vue&type=script&setup=true&lang=ts"
export * from "./list-label-value.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__